export const statusStyles = {
  1: { bg: "#ECFDF3", color: "#027A48" },         // Active
  2: { bg: "#FFE8E8", color: "#F81F1F" },         // Closed
  3: { bg: "#FEEAEB", color: "#D22129" },     // Overdue
  4: { bg: "#898989", color: "white" },           // WrittenOff
  5: { bg: "#EDC7E2", color: "black" },           // Mand. Active
  6: { bg: "#EFE4FF", color: "#6E24E7" },         // Refund
  7: { bg: "#ffb499", color: "black" },           // Paused
  8: { bg: "#ffb499", color: "black" },           // Legal
  9: { bg: "#c2f2f3", color: "black" },           // Settled
};
